import React from "react"
import Carousel from "../../carousel/Carousel"

import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Edges from "../../Edges"

interface IBrandOverviewProps {
  heading: string
  description: string
  icon: any
  slider: {
    image: IImageData
  }[]
}

const BrandCarousel: React.FC<IBrandOverviewProps> = ({
  heading,
  description,
  icon,
  slider,
}) => {
  const brandIcon = icon && getImage(icon.gatsbyImage)

  return (
    <Edges size="md">
      <div className="px-[15px] sm:px-8 lg:px-0 ">
        {brandIcon && (
          <GatsbyImage
            image={brandIcon}
            alt={icon.altText}
            className="mb-8 mt-[40px] max-w-[200px] sm:max-w-[none]"
          />
        )}
        {heading && (
          <h2 className="mb-5 text-h2 uppercase text-darkBlue">{heading}</h2>
        )}
        {description && (
          <p className="mb-8 text-body1 text-darkGrey">{description}</p>
        )}
      </div>

      {slider && (
        <>
          <Carousel
            arrowColor="#072A3F"
            checkLength={slider?.length}
            minImages={4}
          >
            {slider?.map(({ image }, i) => {
              const gatsbyImage = image && getImage(image.gatsbyImage)

              return (
                <div key={i}>
                  {gatsbyImage && (
                    <GatsbyImage
                      image={gatsbyImage}
                      alt={image.altText || ""}
                      className="mx-auto block max-w-[190px] rounded"
                    />
                  )}
                </div>
              )
            })}
          </Carousel>
          <div
            className={
              slider
                ? "relative top-[2px] mx-auto mb-[50px] mt-[57px] max-w-[1250px] border-b-[2px] border-lightGrey"
                : "relative top-[2px] mx-auto mb-[50px] max-w-[1250px] border-b-[2px] border-lightGrey"
            }
          ></div>
        </>
      )}
    </Edges>
  )
}

export default BrandCarousel
